import Vue from "vue";

// msgId -> link ảnh thực sự tải được. PhotoImage ghi lại sau khi ảnh load xong, nhờ đó
// lightbox (preview-src-list của el-image) mở đúng link còn sống thay vì link HD đã 404.
// Dùng Vue.observable để danh sách preview được dựng lại khi cache đổi.
const cache = Vue.observable({});

export function rememberPhotoUrl(key, url) {
  if (!key || !url) return;
  if (cache[key] !== url) Vue.set(cache, key, url);
}

export function resolvedPhotoUrl(key) {
  return key ? cache[key] || "" : "";
}
